angular.module('bizmetryApp').controller('LoginRecoverDialogController', [
  '$scope', '$mdDialog', '$timeout', 'AuthService', 'dialogService',
  function ($scope, $mdDialog, $timeout, AuthService, dialogService) {

    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    $scope.recover = {
      email: '',
      emailValid: false,
      emailTouched: false,
      validationMessage: '',
      submitting: false,
      sent: false
    };

    // 🔥 VALIDACIÓN REAL-TIME
    $scope.$watch('recover.email', function (val) {
      var v = (val || '').trim();

      $scope.recover.emailTouched = v.length > 0;

      if (!v) {
        $scope.recover.emailValid = false;
        $scope.recover.validationMessage = '';
      } else if (!EMAIL_RE.test(v)) {
        $scope.recover.emailValid = false;
        $scope.recover.validationMessage = 'Please enter a valid email address.';
      } else {
        $scope.recover.emailValid = true;
        $scope.recover.validationMessage = '';
      }
    });

    $scope.submit = function () {
      if (!$scope.recover.emailValid || $scope.recover.submitting) return;

      $scope.recover.submitting = true;

      AuthService.recover($scope.recover.email.trim())
        .then(function () {
          $scope.recover.submitting = false;
          $scope.recover.sent = true;
          $timeout(function () { $mdDialog.hide(); }, 2500);
        })
        .catch(function (err) {
          console.error('❌ Recovery request error:', err);
          $scope.recover.submitting = false;
          // NO cerramos el dialog ni marcamos sent = true

          var errorData = err && err.data ? err.data : null;
          var errorMessage = dialogService.formatErrorMessage(errorData || {
            error: 'Connection Error',
            message: 'Could not reach the server. Please check your connection and try again.',
            path: '/v1/api/bizmetry-account/recover',
            timestamp: new Date().toISOString()
          });

          dialogService.showErrorDialog('Account Recovery Failed', errorMessage);
        });
    };

    $scope.cancel = function () {
      $mdDialog.hide();
    };
  }
]);